// eslint-disable-next-line max-len
import { TemplatesAndInstructionsDesktop } from "./templatesAndInstructions/templatesAndInstructionsDesktop";
// eslint-disable-next-line max-len
import { TemplatesAndInstructionsMobile } from "./templatesAndInstructions/templatesAndInstructionsMobile";
// eslint-disable-next-line max-len
import { useTemplatesAndInstructions } from "./templatesAndInstructions/useTemplatesAndInstructions";

export default function TemplatesAndInstructions() {
  const {
    isTablet,
    templates,
    onDownloadTemplate,
    page,
    setPage,
    totalPages,
    searchQuery,
    setSearchQuery,
  } = useTemplatesAndInstructions();

  if (isTablet)
    return (
      <TemplatesAndInstructionsDesktop
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        onDownloadTemplate={onDownloadTemplate}
        templates={templates}
      />
    );

  return (
    <TemplatesAndInstructionsMobile
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      onDownloadTemplate={onDownloadTemplate}
      templates={templates}
    />
  );
}
